$(document).ready(function () {
  $('.toggle-button').on('click', function () {
    $('.toggle-section').toggleClass('collapsed expanded');
    $(this).toggleClass('active');
  });
});
$(document).ready(function(){
   $('a.category-filters-dropdown').on('click', function (e) {
      e.preventDefault();
      $(this).toggleClass('active');
  
      let filterDiv = $('.categories-filters');
  
      if ($(this).hasClass('active')) {
          let fullHeight = filterDiv.prop('scrollHeight') + 'px';
          filterDiv.css('height', fullHeight);
      } else {
          filterDiv.css('height', '35px');
      }
  });
  $('.complementary-btn').click(function () {
        setTimeout(function() {
            location.reload();  // Reload the page after 1 second
        }, 1000);  // 1000 milliseconds = 1 second
  });
  $('.single-product-info .complementary-handwrap button.pro-quick-view').on('click', function() {
    $('.quick-product-view').addClass('complementary');
    
  });
  $('input.search-input').on('input', function() {
    if ($(this).val().length > 0) {
      $('.search-empty').css('display', 'block'); // Show the clear button
    } else {
      $('.search-empty').css('display', 'none'); // Hide the clear button
    }
  });
  
  $('.single-product-info2 .add-to-cart').on('click', function() {
       $('.modal-backdrop').css('opacity', '0').css('transition', 'opacity 0.5s ease-in-out');
    $('.quick-product-view').css('opacity', '0').css('transition', 'opacity 0.5s ease-in-out');
      // Hide elements after 4 seconds
      setTimeout(function() {
          $('.quick-product-view').css('display', 'none');
          $('.quick-product-view').toggleClass('show');
          $('.modal-backdrop').remove();
          $('body').removeClass('modal-open').removeAttr('style');
          $('.quick-product-view')
            .attr('aria-hidden', 'true') 
            .removeAttr('aria-modal')
            .removeAttr('role');  
      }, 2000); // 4000 milliseconds = 4 seconds

      
  });
  $('#buy-it-now2').on('click', function() {
    $('.popup .add-to-cart').addClass('not-loading');
  });
  
  
  


  
  $('.mma-checks-close').on('click', function(e) {
    e.preventDefault(); // Prevent default action of the a tag
    $('.house-of-mma-data .col-md-2').removeClass('active');
    $('.house-of-mma-data .house-of-mma-checks').removeClass('active');
    $('body').removeClass('checkfixed');
  });
  
  $('.filters-button').on('click', function() {
    // Add 'active' class to specified elements
    $('.house-of-mma-data .col-md-2').addClass('active');
    $('.house-of-mma-data .house-of-mma-checks').addClass('active');
    $('body').addClass('checkfixed');
  });
  // When user clicks on the clear button (a tag)
  $('.search-empty').on('click', function(e) {
    e.preventDefault(); // Prevent default action of the a tag
    $('input.search-input').val(''); // Clear the input field
    $(this).css('display', 'none'); // Hide the clear button
    $('.suggestionList').css('display', 'none');
    $('.suggestionList').removeClass('active');
  });
  $('button.navbar-toggler:not(.collapsed)').on('click', function(e) {
    e.preventDefault(); // Prevent default action of the a tag
    $('input.search-input').val(''); // Clear the input field
    $('.search-empty').css('display', 'none'); // Hide the clear button
    $('.suggestionList').css('display', 'none');
    $('.suggestionList').removeClass('active');
  });
  $('.filters-display').on('click', function(e){
    e.preventDefault();
    $('.category-sidebar #filter-form').addClass('filter-active');
    $('.shop-page-data .row .col-lg-2:nth-child(1)').addClass('active');
    
  });
  $('a.menu-sticky-down').on('click', function(e){
    e.preventDefault();
    $(this).toggleClass('active');
    $('.desktop-menu .bottom-nav').toggleClass('active');
  });
  $('.hide-filters').on('click', function(e){
    e.preventDefault();
    $('.category-sidebar #filter-form').removeClass('filter-active');
    $('.shop-page-data .row .col-lg-2:nth-child(1)').removeClass('active');
  });
  $('.mobile-menu .has-dropdown > div > .menu-dropdown-arrow').on('click', function(e) {
      e.preventDefault();
      let t = $(this);
      t.toggleClass('active');
      t.closest('.has-dropdown').find('.zdropdown-menu').slideToggle();
  });


  $('.mobile-menu .child-has-dropdown > div > .menu-dropdown-arrow').on('click' , function(e){
		e.preventDefault();
		t = $(this);
    t.toggleClass('active');
		t.closest('li').find('ul').slideToggle();
	});
$('.shipping-slider').owlCarousel({
    loop: true,
    margin: 10,
    nav: false,        // Disable arrows
    dots: false,       // Disable dots
    autoplay: true,    // Enable autoplay
    autoplayTimeout: 3000,  // Set autoplay interval (optional)
    autoplayHoverPause: true, // Pause autoplay on hover
    responsive: {
        0: {
            items: 1
        },
        600: {
            items: 1
        },
        1000: {
            items: 1
        }
    }
});



  $('.owl-theme').owlCarousel({
    loop: true,
    margin: 15,
    nav: false,           
    dots: false,         
    autoplay: true,       
    autoplayTimeout: 3000, 
    autoplayHoverPause: true, 
    responsive: {
        0: {
            items: 1
        },
        600: {
            items: 3
        },
        1000: {
            items: 5
        }
    }
  });
var owl = $('.owl-theme2');
owl.owlCarousel({
    loop:true,
    nav:true,
    margin:10,
    responsive:{
        0:{
            items:1
        },
        500:{
            items:1
        },            
        960:{
            items:2
        }
    }
});

  
});

$(document).on('click', function (e) {
  if (
    !$(e.target).closest('.category-sidebar #filter-form').length &&
    !$(e.target).closest('.filters-display').length
  ) {
    $('.category-sidebar #filter-form').removeClass('filter-active');
    $('.shop-page-data .row .col-lg-2:nth-child(1)').removeClass('active');
  }
});
$(document).ready(function () {
    // Handle item removal
    $(document).on("click", ".item-remove", function (e) {
        e.preventDefault();

        // Get variant ID from the clicked button
        const variantId = $(this).attr("variant-id");

        if (!variantId) {
            console.error("Error: Variant ID is missing.");
            alert("Unable to remove item. Please try again.");
            return;
        }

        $(this).addClass("removing");

        // Perform AJAX request to remove the item
        $.ajax({
            type: "POST",
            url: "/cart/change.js",
            data: {
                id: variantId, // Use the variant ID
                quantity: 0,   // Setting quantity to 0 removes the item
            },
            dataType: "json",
            success: function (response) {
                // Remove the item from the DOM
                const $parentItem = $(`[variant-id="${variantId}"]`).closest(".cart-sidebar-item");
                $parentItem.fadeOut(300, function () {
                    $(this).remove();

                    // Handle empty cart
                    if (response.item_count === 0) {
                        console.log("Cart is now empty.");
                        $(".cart-sidebar-total-price, .cart-sidebar-subtotal-price").text("$0.00");
                        $(".cart-sidebar-items").html("<p>Your cart is empty.</p>");
                    }
                });

                // Update cart counts
                updateCartItemCounts(response.item_count);

                // Refresh the cart drawer
                updateCartDrawer();
            },
            error: function (xhr, status, error) {
                console.error("Error removing item:", xhr.responseJSON || xhr.responseText);
                alert("Failed to remove the item. Please try again.");
            },
            complete: function () {
                // Remove the "removing" class to reset the button's state
                $(".item-remove").removeClass("removing");
            },
        });
    });

    // Update cart item counts
    function updateCartItemCounts(itemCount) {
        $(".cart-count").text(itemCount);
    }

    // Refresh cart drawer content
    function updateCartDrawer() {
        $.ajax({
            url: "/?section_id=minicart",
            method: "GET",
            success: function (data) {
                // Update cart sidebar content
                const html = document.createElement("div");
                html.innerHTML = data;
                const newCartContent = html.querySelector(".cart-sidebar-inner").innerHTML;
                $(".cart-sidebar-inner").html(newCartContent);

                // Reapply listeners for the updated cart drawer
                addCartDrawerListeners();
            },
            error: function () {
                console.error("Error refreshing cart drawer.");
            },
        });
    }

    
});



$(document).ready(function() {
    $(document).on('change', '.product-option input', function() {

        var allSelected = true;

        // Loop through each fieldset in .product-option
        $('.product-option fieldset').each(function() {
            if ($(this).find('input:checked').length === 0) {
                allSelected = false; // At least one fieldset has nothing selected
            }
        });

        if (allSelected) {
            $('.single-product-info').addClass('both-selected');
            $('.single-product-info2').addClass('both-selected');
        } else {
            $('.single-product-info').removeClass('both-selected');
            $('.single-product-info2').removeClass('both-selected');
        }
    });
});


$(document).ready(function() {
  $('input.search-input').on('click', function() {
    // Remove 'collapsed' class from .navbar-toggler
    $('.navbar-toggler').removeClass('collapsed');

    // Set 'aria-expanded' to 'true'
    $('.navbar-toggler').attr('aria-expanded', 'true');

    // Add 'show' class to .navbar-toggler
    $('.navbar-collapse').addClass('show');
  });
});




document.addEventListener("DOMContentLoaded", function() {
    // Function to initialize swatch functionality for any given set of swatches
    function initializeSwatchFunctionality(swatches) {
        swatches.forEach(function(swatch) {
            swatch.addEventListener("click", function() {
                const productId = swatch.getAttribute("data-product-id");
                const productCard = document.querySelector(`.product-card[data-product-id='${productId}']`);
                const variantImage = swatch.getAttribute("data-variant-image");
                const productImage = productCard.querySelector(".product-image a img");

                if (!productImage) {
                    console.error(`Product image not found for product ID ${productId}`);
                    return;
                }

                // Uncheck and deselect other swatches in the same product card
                const allSwatches = productCard.querySelectorAll(".color-swatches input[type='checkbox']");
                allSwatches.forEach(s => {
                    if (s !== swatch) {
                        s.checked = false;
                        s.classList.remove("selected");
                    }
                });

                // Add 'selected' class and update image
                if (swatch.checked) {
                    swatch.classList.add("selected");
                    if (variantImage && variantImage.trim() !== "" && variantImage !== "undefined") {
                        productImage.src = variantImage;
                    }
                } else {
                    swatch.classList.remove("selected");
                }
            });
        });
    }

    // 1. Handle swatches on the initial page load (for the shop page)
    const initialSwatches = document.querySelectorAll(".color-swatches input[type='checkbox']");
    if (initialSwatches.length > 0) {
        console.log("Initial swatches found:", initialSwatches.length);
        initializeSwatchFunctionality(initialSwatches);
    }

    // 2. Handle swatches in the recommendations section (dynamically loaded)
    const productRecommendationsSection = document.querySelector(".product-recommendations");

    if (productRecommendationsSection) {
        const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.addedNodes.length) {
                    const swatches = productRecommendationsSection.querySelectorAll(".color-swatches input[type='checkbox']");
                    if (swatches.length > 0) {
                        console.log("Dynamically loaded swatches found:", swatches.length);
                        initializeSwatchFunctionality(swatches);
                    }
                }
            });
        });

        // Observe the recommendations section for dynamically added content
        observer.observe(productRecommendationsSection, { childList: true, subtree: true });
    }
});









function validateSearchForm() {
    const searchInput = document.getElementsByClassName('search-input');
    // Prevent form submission if the input is empty or only contains spaces
    return searchInput.value.trim() !== '';
}



// Function to decode HTML entities
function decodeHtmlEntities(str) {
  const textArea = document.createElement('textarea');
  textArea.innerHTML = str;
  return textArea.value;
}

async function suggestionList(e) {
  const suggestionList = e.closest('form').querySelector('.suggestionList');

  if (e.value.length > 0) {
    suggestionList.style.display = 'block';
    suggestionList.classList.add('active');

    let thisVal = e.value.trim();  // Keep the input as is
    const thisType = e.closest('form').querySelector('input[name="type"]').value;

    // Manually replace the apostrophe with its HTML entity
    thisVal = thisVal.replace(/'/g, '&#39;');  // Replace all apostrophes with &#39;

    // Encode the value for URL
    const query = encodeURIComponent(thisVal.split(/\s+/).join(' '));  // Properly encode spaces and special chars
    
    const req = await fetch(`/search?view=ajax&type=${thisType}&q=${query}`);
    const { items: res } = await req.json();

    suggestionList.innerHTML = '';

    if (res.length > 0) {
      const queryWords = thisVal.toLowerCase().split(/\s+/);  // Normalize input for comparison
      const filteredItems = res
      .map(item => {
        const title = item.title.toLowerCase();
        const skus = item.skus || [];

        const lowercasedSKUs = skus.map(s => s.toLowerCase());
        const matchedIndex = lowercasedSKUs.findIndex(sku =>
          queryWords.some(word => sku.includes(word))
        );

        const matchedSKU = matchedIndex !== -1 ? skus[matchedIndex] : null;

        const matches = queryWords.every(word =>
          title.includes(word) || lowercasedSKUs.some(sku => sku.includes(word))
        );

        return matches ? { ...item, matchedSKU } : null;
      })
      .filter(Boolean);

      if (filteredItems.length > 0) {
        const ul = document.createElement('ul');

        filteredItems.forEach(item => {
          const li = document.createElement('li');
          const a = document.createElement('a');

          const cleanUrl = item.url.split('?')[0] + (item.url.includes('variant') ? '?' + item.url.split('?')[1] : '');
          a.href = cleanUrl;

          const imageDiv = document.createElement('div');
          imageDiv.classList.add('image-wrapper');
          if (item.image) {
            const img = document.createElement('img');
            img.src = `https://${window.location.host}/cdn/shop/${item.image}`;
            img.alt = decodeHTMLEntities(item.title); // decode here for alt text
            img.style.width = '50px';
            imageDiv.appendChild(img);
          }
          a.appendChild(imageDiv);

          const contentDiv = document.createElement('div');
          contentDiv.classList.add('content-wrapper');

          const title = document.createElement('span');
          title.innerText = decodeHTMLEntities(item.title); // decode title text
          title.style.fontWeight = 'bold';
          contentDiv.appendChild(title);

          const detailsDiv = document.createElement('div');
          detailsDiv.classList.add('details-wrapper');

          if (item.matchedSKU) {
            const sku = document.createElement('span');
            sku.innerText = ` (SKU: ${item.matchedSKU})`;
            detailsDiv.appendChild(sku);
          }

          const priceDiv = document.createElement('div');
          priceDiv.classList.add('price-wrapper');

          if (item.price_range) {
            const priceRange = document.createElement('span');
            priceRange.classList.add('p-range-price');
            priceRange.innerHTML = item.price_range;
            priceDiv.appendChild(priceRange);
          }

          if (item.compare_at_price && item.compare_at_price !== 'null') {
            const comparePrice = document.createElement('span');
            comparePrice.classList.add('compare-at-price');
            comparePrice.innerText = `${item.compare_at_price}`;
            priceDiv.appendChild(comparePrice);
          }

          detailsDiv.appendChild(priceDiv);
          contentDiv.appendChild(detailsDiv);

          a.appendChild(contentDiv);
          li.appendChild(a);
          ul.appendChild(li);
        });

        suggestionList.appendChild(ul);
      } else {
        const li = document.createElement('li');
        li.innerText = 'No results found';
        suggestionList.appendChild(li);
      }
    } else {
      const li = document.createElement('li');
      li.innerText = 'No results found';
      suggestionList.appendChild(li);
    }
  } else {
    suggestionList.innerHTML = '';
    suggestionList.style.display = 'none';
    suggestionList.classList.remove('active');
  }
}


// Decode function
function decodeHTMLEntities(text) {
  const txt = document.createElement('textarea');
  txt.innerHTML = text;
  return txt.value;
}



// Add event listeners for focus and blur
document.addEventListener("DOMContentLoaded", function() {
  const searchInput = document.querySelector('input.search-input');
  const suggestionList = document.querySelector('.suggestionList');

  searchInput.addEventListener('focus', function() {
    if (this.value.length > 0) {
      suggestionList.style.display = 'block';
      
    }
  });

  searchInput.addEventListener('blur', function() {
    // Use setTimeout to allow click events on suggestions to register
    setTimeout(() => {
      suggestionList.style.display = 'none';
    }, 200);
  });
});




// Function to remove specific query parameters
function removeQueryParameters() {
    const paramsToRemove = ['_pos', '_sid', '_ss']; // Parameters to remove
    const url = new URL(window.location.href);
    let paramsChanged = false;

    paramsToRemove.forEach(param => {
        if (url.searchParams.has(param)) {
            url.searchParams.delete(param);
            paramsChanged = true;
        }
    });

    // If any parameters were changed, update the URL without reloading the page
    if (paramsChanged) {
        window.history.replaceState({}, document.title, url.pathname + url.search);
    }
}

// Run the function after ensuring the product page has loaded
window.addEventListener('load', function() {
    const productContainer = document.querySelector('.product-single'); // Replace with actual product container class or ID

    if (productContainer) {
        // Wait until the product content is fully loaded
        const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                    // Product content has loaded, now we can safely remove the parameters
                    removeQueryParameters();
                    // Stop observing after the content is loaded
                    observer.disconnect();
                }
            });
        });

        // Start observing the product container for changes
        observer.observe(productContainer, { childList: true, subtree: true });
    } else {
        // If product container is not found, fallback to removing parameters on load
        removeQueryParameters();
    }
});





















document.addEventListener('DOMContentLoaded', function() {
  updateCartCount();

  function updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        let cartCountElements = document.querySelectorAll('.cart-count');
        let cartCount = cart.item_count;

        cartCountElements.forEach(cartCountElement => {
          if (cartCount > 0) {
            cartCountElement.textContent = cartCount;
            cartCountElement.style.display = 'flex'; // Show when items are in the cart
          } else {
            cartCountElement.style.display = 'none'; // Hide when no items in the cart
          }
        });
      });
  }

  document.addEventListener('cart:updated', updateCartCount);
});


document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
  form.addEventListener('submit', function() {
    setTimeout(() => {
      document.dispatchEvent(new Event('cart:updated'));
    }, 1000); // Adjust timeout as needed
  });
});















var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "$";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

// JavaScript to handle clicks outside the sidebar
document.addEventListener('click', function(event) {
    // Get the sidebar element
    var sidebar = document.querySelector('.cart-sidebar');
    var sidebar_parent = document.querySelector('.cart-sidebar-parent');
    
    // Check if the clicked element is outside the sidebar
    if (!sidebar.contains(event.target)) {
        // If clicked outside, add 'hidden' class and remove 'active' class
        sidebar.classList.add('hidden');
        sidebar_parent.classList.remove('active');
    }
});



function OpenCartDrawer() {

        document.querySelector('.cart-sidebar-parent').classList.add('active');
        document.querySelector('.cart-sidebar').classList.remove('hidden');
        
}

function CloseCartDrawer() {
    document.querySelector('.close-sidebar').addEventListener('click', function() {
    
            document.querySelector('.cart-sidebar').classList.add('hidden');
            document.querySelector('.cart-sidebar-parent').classList.remove('active');
        }); 
}

function updateCartItemCounts(count) {
  document.querySelectorAll(".cart-count").forEach((el) => {
    el.textContent = count;
  });
}

async function updateCartDrawer() {
    const res = await fetch("/?section_id=minicart");
    const text = await res.text();
    const html = document.createElement("div");
    html.innerHTML = text;
    
    const newBox = html.querySelector(".cart-sidebar-inner").innerHTML;
    document.querySelector(".cart-sidebar-inner").innerHTML = newBox;
    
    addCartDrawerListeners();
    
}



function addCartDrawerListeners() {
  // Update quantities
  document.querySelectorAll(".minicart-quantity button").forEach((button) => {
    button.addEventListener("click", async () => {
      // Get line item key
      const rootItem = button.closest(".cart-sidebar-item");
      const key = rootItem.getAttribute("data-line-item-key");

      // Get the input element and current quantity
      const input = button.parentElement.querySelector("input");
      const currentQuantity = Number(input.value);
      const isUp = button.classList.contains("minicart-quantity-plus");

      // Get the minimum and maximum quantity values from input attributes
      const minQuantity = Number(input.getAttribute("min")) || 1;
      const maxQuantity = Number(input.getAttribute("data-max"));

      // Calculate the new quantity within min and max bounds
      const newQuantity = isUp
        ? Math.min(currentQuantity + 1, maxQuantity)
        : Math.max(currentQuantity - 1, minQuantity);

      // Prevent the update if new quantity is the same as current
      if (newQuantity === currentQuantity) {
        return;
      }

      // Add the 'incrementing' class to button and parent container
      button.classList.add("incrementing");
      const btnContainer = rootItem.querySelector(".cart-sidebar-item-btns");
      if (btnContainer) {
        btnContainer.classList.add("updating");
      }

      // Perform the AJAX update without updating input value until response
      try {
        const res = await fetch("/cart/update.js", {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates: { [key]: newQuantity } }),
        });

        const cart = await res.json();
        updateCartItemCounts(cart.item_count);

        // Set the input value to newQuantity once AJAX completes
        input.value = newQuantity;

        // Update cart drawer to reflect any further changes
        updateCartDrawer();

      } catch (error) {
        console.error("Error updating cart:", error);
      } finally {
        // Remove the 'incrementing' and 'updating' classes after update completes or fails
        button.classList.remove("incrementing");
        if (btnContainer) {
          btnContainer.classList.remove("updating");
        }
      }
    });
  });
}

addCartDrawerListeners();








document.addEventListener('DOMContentLoaded', function() {
  // Use event delegation to handle all form submissions
  document.addEventListener('submit', async function (event) {
    const form = event.target;

    // Check if the form is for adding to the cart
    if (form.matches('form[action="/cart/add"]')) {
        event.preventDefault(); // Prevent the default form submission

        // Add the product to the cart
        await fetch("/cart/add", {
            method: "POST",
            body: new FormData(form),
        });

        // Start interval to update cart details every second
        const intervalId = setInterval(async () => {
            const res = await fetch("/cart.js");
            const cart = await res.json();

            // Update cart functions
            updateCartItemCounts(cart.item_count);
            await updateCartDrawer();

            // If the cart is updated and open, stop the interval
            if (cart.item_count > 0) {
                OpenCartDrawer();
                CloseCartDrawer();
                clearInterval(intervalId); // Stop further updates
            }
        }, 1000); // Update every second
    }
  });

  // Observe the product recommendations section
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations'); 

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  
  // Check if productRecommendationsSection exists before observing
  if (productRecommendationsSection) {
    const observer = new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 200px 0px' });
    observer.observe(productRecommendationsSection);
  } else {
    console.warn("Product recommendations section not found.");
  }
});

























